import { render } from "./Index.vue?vue&type=template&id=c397c8b6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c397c8b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c397c8b6"],['__file',"components/Customers/Standings/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c397c8b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c397c8b6', __exports__)) {
    api.reload('c397c8b6', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=c397c8b6&scoped=true", () => {
    api.rerender('c397c8b6', render)
  })

}


export default __exports__